import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Spinner, Alert } from 'react-bootstrap';
import { handleGoogleCallback } from './authenticationSlice';

export const GoogleCallback = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const processCallback = async () => {
      try {
        // Parse URL parameters
        const params = new URLSearchParams(location.search);
        const encodedToken = params.get('token');
        const error = params.get('error');
        const errorMessage = params.get('message');

        // Handle errors from backend
        if (error) {
          const errorMessages = {
            'unauthorized_domain': 'Only @gearinc.com email addresses are allowed',
            'user_creation_failed': 'Unable to create your account. Please try again.',
            'account_inactive': 'Your account has been deactivated',
            'sso_failed': errorMessage || 'SSO authentication failed'
          };
          setError(errorMessages[error] || 'Authentication failed. Please try again.');
          setLoading(false);
          return;
        }

        // Decode the authentication token
        if (!encodedToken) {
          setError('No authentication data received. Please try again.');
          setLoading(false);
          return;
        }

        // Decode base64 encoded authentication data
        const decodedData = JSON.parse(atob(encodedToken));
        
        if (decodedData && decodedData.access_token) {
          // Dispatch the authentication data
          await dispatch(handleGoogleCallback(decodedData));
          
          // Redirect to home page
          history.push('/');
        } else {
          setError('Invalid authentication data. Please try again.');
          setLoading(false);
        }
      } catch (err) {
        console.error('Google callback error:', err);
        setError('Authentication failed. Please try again.');
        setLoading(false);
      }
    };

    processCallback();
  }, [dispatch, history, location]);

  if (loading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Completing sign in...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <Alert variant="danger">
          <Alert.Heading>Authentication Error</Alert.Heading>
          <p>{error}</p>
          <hr />
          <div className="d-flex justify-content-end">
            <button className="btn btn-outline-danger" onClick={() => history.push('/login')}>
              Back to Login
            </button>
          </div>
        </Alert>
      </div>
    );
  }

  return null;
};

